// import { EventFilters } from "types/IEvent"
import { useCallback, useMemo, useState } from "react"
// import { UserFilters } from "types/IAccessControl"
import styled from "styled-components"
import Modal from "components/EvtKit/modal/Modal"
import { FaTrashAlt } from "react-icons/fa"
import { Search2Icon } from "@chakra-ui/icons"
import InputComponent from "./InputComponent"

export const ContainerGeneralFilters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`

export const ContainerFilters = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 18px;
  background-color: ${(props) => props.theme.palette.white};
  padding-top: 24px;
  border-radius: 10px;
  align-items: center;
`

export const ClearFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  flex-direction: row;
  cursor: pointer;
  gap: 4px;
`

export const TextInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ContainerTitleClearFilters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  gap: 8px;

  color: ${(props) => props.theme.palette.white};

  padding: 0 20px;
  height: 40px;
  width: 340px;

  background: ${(props) => props.theme.palette.primary_one};

  overflow: hidden;
  cursor: pointer;

  transition: 0.2s;

  &:not(.disabled) {
    background: ${(props) => props.theme.palette.primary_one} 100%;
    &:hover {
      background: ${(props) => props.theme.palette.secondary_four};
    }
    transition-delay: 0.01s;
  }

  &.disabled {
    background: ${(props) => props.theme.palette.disabled};
    color: ${(props) => props.theme.palette.white};
    cursor: not-allowed;
  }

  &.fill-width {
    width: 100%;
  }

  &.primary {
    background: ${(props) => props.theme.palette.primary_one};
  }

  &.informative {
    background: ${(props) => props.theme.palette.informative};
  }

  &.freeTrial {
    background: ${(props) => props.theme.palette.secondary_four};
  }

  &.premium {
    background: ${(props) => props.theme.palette.white};
    color: ${(props) => props.theme.palette.primary_one};
  }

  &.button-api-key-copy {
    background: ${(props) => props.theme.palette.primary_one};
    &:hover {
      background: ${(props) => props.theme.palette.primary_one};
    }
  }

  &.secondary {
    background:
      linear-gradient(white, white) padding-box,
      linear-gradient(
          to top,
          ${(props) => props.theme.palette.primary_one},
          ${(props) => props.theme.palette.primary_one}
        )
        border-box;
    border-radius: 40px;
    border: 1px solid transparent;
    color: ${(props) => props.theme.palette.primary_one};
  }
`

const StyledButton2 = styled(StyledButton)`
  color: ${(props) => props.theme.palette.primary_one};
  border: 1px solid ${(props) => props.theme.palette.primary_one};
  color: ${(props) => props.theme.palette.primary_one};
  &:not(.disabled) {
    background: ${(props) => props.theme.palette.white};
    &:hover {
      background: ${(props) => props.theme.palette.secondary_four};
      color: ${(props) => props.theme.palette.white};
    }
    transition-delay: 0.01s;
  }
`

interface TableFilterProps {
  open: boolean
  onClose: () => void
  filtersFields: readonly {
    Header: () => JSX.Element
    accessor: string
    filter?: {
      name: string
      type: string
      label: string
      placeholder?: string
      selectOptions?: { label: string; value: string }[]
    }
  }[]
  initialFilters: App.AccountFilters | any
  setFilterCallback: (state: App.AccountFilters | any) => void
}

export const TableFilter = ({ open, onClose, filtersFields, initialFilters, setFilterCallback }: TableFilterProps) => {
  const [filters, setFilters] = useState(initialFilters)

  const onDateFilterChange = useCallback((filterName, dates: Array<Date | null>) => {
    const [start, end] = dates

    setFilters((prevState) => ({
      ...prevState,
      [`${filterName}Start`]: start || undefined,
      [`${filterName}End`]: end || undefined
    }))
  }, [])

  const onTextFieldChange = useCallback((field: string, e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters((prevState) => ({ ...prevState, [field]: e.target.value }))
  }, [])

  const onSelectChange = useCallback((name: string, value: string) => {
    setFilters((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }, [])

  const clearFilters = useCallback(() => {
    setFilters({})
  }, [])

  const applyFilters = useCallback(() => {
    setFilterCallback(filters)
    onClose()
  }, [filters])

  const enableClearFilter = useMemo(() => Object.values(filters).some((item) => !!item), [filters])

  return (
    <Modal openModal={open} closeModal={onClose} title="Filtros">
      <>
        <ContainerFilters>
          {filtersFields.map((column) => (
            <InputComponent
              key={column.accessor}
              column={column}
              filters={filters}
              onTextFieldChange={(e) => onTextFieldChange(column.accessor, e)}
              onDateFilterChange={onDateFilterChange}
              onSelectChange={onSelectChange}
            />
          ))}
        </ContainerFilters>
        <span style={{ display: "flex", justifyContent: "space-between", paddingTop: "48px" }}>
          <StyledButton2 onClick={clearFilters} disabled={!enableClearFilter}>
            <span>
              <FaTrashAlt />
            </span>
            Limpar Filtros
          </StyledButton2>
          <StyledButton onClick={applyFilters}>
            <span>
              <Search2Icon rotate={90} />
            </span>
            Aplicar filtros e pesquisar
          </StyledButton>
        </span>
      </>
    </Modal>
  )
}
